module.exports = __webpack_public_path__ + "static/media/RightImg.8b3810bf.png";